import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

function ProtectedRoute({ children, requireAdmin = false, requireManager = false }) {
  const { user, loading, isAuthenticated, isAdmin, isManager } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  if (requireManager && !(isAdmin() || isManager())) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;
